import React from 'react';

// this icon is the blue outline hand in the stopped position
export const TriangleWarning = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--triangle-warning';
  color = color || '#BA4E00';

  return (
    <svg
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ className }}
    >
      <path
        d="M11 7.00001V12M11 14.5H11.01M9.36299 1.59101L1.25699 15.125C1.08988 15.4144 1.00145 15.7425 1.0005 16.0766C0.999539 16.4108 1.08609 16.7394 1.25153 17.0297C1.41698 17.3201 1.65555 17.562 1.94353 17.7316C2.2315 17.9011 2.55884 17.9923 2.89299 17.996H19.107C19.441 17.9922 19.7682 17.901 20.056 17.7315C20.3438 17.562 20.5823 17.3202 20.7477 17.03C20.9131 16.7398 20.9997 16.4114 20.9989 16.0774C20.9981 15.7434 20.9098 15.4154 20.743 15.126L12.637 1.59001C12.4664 1.30851 12.2262 1.07575 11.9394 0.914203C11.6527 0.752657 11.3291 0.667786 11 0.667786C10.6709 0.667786 10.3473 0.752657 10.0605 0.914203C9.77378 1.07575 9.53353 1.30851 9.36299 1.59001V1.59101Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TriangleWarning;
